import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGreenBook = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 200 164"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#007A3D"
      d="m64.305 3.768 131.537 18.907a4.85 4.85 0 0 1 4.108 5.49l-47.376 329.431a4.86 4.86 0 0 1-1.894 3.192 4.854 4.854 0 0 1-3.597.916L15.619 342.858a4.85 4.85 0 0 1-3.192-1.894 4.85 4.85 0 0 1-.917-3.596L58.863 7.876a4.85 4.85 0 0 1 5.442-4.108"
    />
    <path
      fill="#000"
      d="m64.305 3.768 131.537 18.907a4.85 4.85 0 0 1 4.108 5.49l-47.376 329.431a4.86 4.86 0 0 1-1.894 3.192 4.854 4.854 0 0 1-3.597.916L15.619 342.858a4.85 4.85 0 0 1-3.192-1.894 4.85 4.85 0 0 1-.917-3.596L58.863 7.876a4.85 4.85 0 0 1 5.442-4.108"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m195.224 22.59.618.085a4.85 4.85 0 0 1 4.108 5.49l-47.376 329.431a4.86 4.86 0 0 1-1.894 3.192 4.854 4.854 0 0 1-3.597.916l-.618-.084a4.86 4.86 0 0 1-3.191-1.894 4.86 4.86 0 0 1-.917-3.597l47.376-329.406a4.85 4.85 0 0 1 5.491-4.133"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="M194.956 28.802 69.126 11.007 23.18 335.908l125.83 17.794z"
    />
    <path
      fill="#007A3D"
      d="m68.692 11.67 122.411 17.586-46.419 322.971-122.678-15.708z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m68.692 11.67 119.951 13.259-46.686 324.849-119.95-13.259z"
    />
    <path
      fill="#007A3D"
      d="m68.692 11.67 116.63 12.786-47.486 323.226-115.83-11.163z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m68.692 11.67 115.454 11.065-47.874 323.226-114.266-9.442z"
    />
    <path
      fill="#007A3D"
      d="m68.692 11.67 110.764 10.617-47.001 321.625-110.449-7.393z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m68.692 11.67 107.176 9.284-47.534 321.662-106.328-6.097z"
    />
    <path
      fill="#007A3D"
      d="m68.692 11.67 99.48 8.617-47.546 321.88-98.62-5.648z"
      opacity={0.2}
    />
    <path
      fill="#007A3D"
      d="m93.571 0-.087 1.282 7.956.542.087-1.282zM109.134 1.062l-.087 1.282 23.507 1.602.087-1.281zM159.203 8.98 54.123 1.828a6.896 6.896 0 0 0-7.271 5.89L.069 333.126a6.89 6.89 0 0 0 3.643 7.091c.84.437 1.762.697 2.708.762l105.079 7.163a6.9 6.9 0 0 0 7.272-5.902l46.771-325.395a6.91 6.91 0 0 0-6.339-7.866"
    />
    <path
      fill="#fff"
      d="M104.021 338.095h-.29l-93.433-6.363a4.341 4.341 0 0 1-3.987-4.933L51.42 12.955a4.315 4.315 0 0 1 4.57-3.636l93.432 6.362a4.314 4.314 0 0 1 3.987 4.933l-45.098 313.76a4.35 4.35 0 0 1-4.291 3.721M55.699 10.519a3.054 3.054 0 0 0-3.005 2.605L7.584 327.03a3.065 3.065 0 0 0 2.811 3.467l93.42 6.363a3.08 3.08 0 0 0 3.224-2.606L152.137 20.42a3 3 0 0 0-.642-2.339 3.05 3.05 0 0 0-2.157-1.127l-93.432-6.363z"
      opacity={0.2}
    />
  </svg>
);
export default SvgGreenBook;
